import React, { useEffect, useState } from "react";
import { ADMIN_DASHBOARD, ADMIN_PROFILE, ADMIN_SIDEBAR_HR, ADMIN_SIDEBAR_USER, WEBSITEMANGER_ICON } from "../../../../utils/app-image-contant";
import { ROUTES } from "../../../../hooks/routes/url-constant";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {

  const RoleAndPermission = useSelector((state) => state?.adminRoleAndPermission?.value);

  const [menu, setMenu] = useState([
    {
      label: "Dashboard",
      link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.DASHBOARD,
      access: RoleAndPermission?.isDashboard,
      active: true,
      icon: ADMIN_DASHBOARD,
      accessLavel: [1, 2, 3, 4, 5, 6],
      submenu:[]

    },
    {
      label: "User Management",
      link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.USER_LIST,
       access: RoleAndPermission?.isUserManagement,
      active: false,
      icon: ADMIN_SIDEBAR_USER,
      accessLavel: [2, 4, 5, 6],
      submenu:[]
    },
    {
      label: "Recruitment",
      link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.RECRUITMENT_LIST,
      access: RoleAndPermission?.isRecruitment,
      active: false,
      icon: ADMIN_SIDEBAR_HR,
      accessLavel: [3, 5, 6],
      submenu:[]
    },

    {
      label: "Website Manage",
      link: "",
      access: RoleAndPermission?.isWebsiteManagament,
      accessLavel: [3, 4, 5, 6],
      active: false,
      icon: WEBSITEMANGER_ICON,
      submenu: [
        {
          label: "Update Banner",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.UPDATE_BANNER,
          access: RoleAndPermission?.websiteManagementSubMenu?.isBanner,
          accessLavel: [3, 4, 5, 6],
          active: true
          // icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Tender",
          link: process.env.PUBLIC_URL + "/admin/TenderList/1", // Update the link for Tender if needed
          access: RoleAndPermission?.websiteManagementSubMenu?.isTender,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Upload Photo",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.IMAGE_LIST,
          access: RoleAndPermission?.websiteManagementSubMenu?.isImage,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Product Portfolio",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.LIST_PRODUCTPORTFOLIO,
          access: RoleAndPermission?.websiteManagementSubMenu?.isProduct,
          active: false,
          accessLavel: [6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Update Kendra Info.",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.LIST_KENDRADATA,
          access: RoleAndPermission?.websiteManagementSubMenu?.isKendra,
          active: false,
          accessLavel: [5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Distributor Update",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.LIST_LOCATE_DISTRIBUTOR,
          access: RoleAndPermission?.websiteManagementSubMenu?.isLocate,
          active: false,
          accessLavel: [6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Pharmacist Details",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.PHARMACIST_LIST,
          access: RoleAndPermission?.websiteManagementSubMenu?.isPharmacist,
          active: false,
          icon: ADMIN_SIDEBAR_HR,
          accessLavel: [4, 5, 6]
        },
        {
          label: "Contact Details",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.LIST_CONTACT,
          access: RoleAndPermission?.websiteManagementSubMenu?.isContact,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Team Management",
          link: process.env.PUBLIC_URL + "/admin/" + ROUTES?.ADMIN.MANAGAMENT_LIST,
          access: RoleAndPermission?.websiteManagementSubMenu?.isTeam,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "News Management",
          link: process.env.PUBLIC_URL + "/admin/news-list/WhatsNew" ,
          access: RoleAndPermission?.websiteManagementSubMenu?.isNews,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Reports",
          link: process.env.PUBLIC_URL + "/admin/report-list/Annual" ,
          access: RoleAndPermission?.websiteManagementSubMenu?.isReports,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
        {
          label: "Media",
          link: process.env.PUBLIC_URL + "/admin/media-list/EventGallery" ,
          access: RoleAndPermission?.websiteManagementSubMenu?.isMedia,
          active: false,
          accessLavel: [4, 5, 6],
          icon: ADMIN_SIDEBAR_HR
        },
      ]
    },

  ])
 

  useEffect(() => {
    if (localStorage.getItem("nMenuData")) {
      setMenu(JSON?.parse(localStorage.getItem("nMenuData")));
    } else {
      setMenu(menu)
    }
  }, []);

  const handleClickMenu = (idx,subindex) => {
    let nMenuData = menu.map((d, i) => {
      const nobj = d?.submenu?.map((subdata,sindx)=>{
        return { ...subdata, active: sindx === subindex || false };
      })
      return { ...d, active: i === idx || false ,submenu :nobj};
    });
    localStorage.setItem("nMenuData", JSON.stringify(nMenuData));
    setMenu(nMenuData);

  };

  const handleClickSubMenu = (index,subindex) =>{
    let nMenuData = menu.map((d, i) => {
      if(index === i  ){
        const nobj = d?.submenu?.map((subdata,sindx)=>{
          return { ...subdata, active: sindx === subindex || false };
        })
        return {...d,active: i === index  ,submenu :nobj}
      }
      else{
        return { ...d,  active: i === index || false ,submenu:[] };
      }
      
      
    });
    localStorage.setItem("nMenuData", JSON.stringify(nMenuData));
    setMenu(nMenuData);
  }

  return (
    <>
    <div className="navbaradminside">
    <nav class="sidebar navbarside" id="side-bar-show">
        <div class="d-flex justify-content-between">
          <a class="small_logo" href="index.html">
            <img src="img/mini_logo.jpg" alt />
          </a>
          <div class="sidebar_close_icon d-lg-none">
            <i class="ti-close " id="ti-cross-button"></i>
          </div>
        </div>
        <div className="navbar-bg">
          <ul id="sidebar_menu">
            <div class="profile-userpic">
              <img src={RoleAndPermission?.adminProfile || "https://janaushadhi.gov.in:10443/jasprodobt/AdminImages/daabcc555edf6081.jpg"} class="img-responsive" alt="" />
            </div>
            <div class="profile-usertitle">
              <div class="profile-usertitle-name">
                {RoleAndPermission?.userName}
              </div>
              <div class="profile-usertitle-job">
                <button type="button" class="btn  btn-sm">{RoleAndPermission?.roleName}</button>
              </div>
              <hr />
            </div>
            {menu && menu?.map((navaccess, index) => {
                if (navaccess.access === 1) {
                 if (navaccess.label === "Website Manage") {
                  return (
                    <li className={navaccess?.active ? "mb-1 web-manager active" : "mb-1 web-manager"}
                      >
                      <a className="has-arrow text-left btn btn-toggle align-items-center" data-bs-toggle="collapse" data-bs-target={`#submenu-collapse-${index}`} aria-expanded="true">
                        <div className="nav_icon_small">
                          <img src={navaccess.icon} alt="home-icon" />
                        </div>
                        <div className="nav_title text-start">
                          <span>{navaccess.label}</span>
                        </div>
                      </a>
                      <div className="collapse" id={`submenu-collapse-${index}`}>
                        <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                          {navaccess.submenu.map((submenuItem, subIndex) => {
                              if (submenuItem.access === 1) {
                         
                              return (
                                < >
                                  <hr />
                                  <li key={subIndex} className={submenuItem?.active ? "mb-1 submenu active" : "mb-1"}  onClick={(e) => handleClickSubMenu(index,subIndex)}  ><Link  to={submenuItem.link}> {submenuItem.label}</Link></li>
                                </>)
                            }


                          })}
                        </ul>
                      </div>
                    </li>
                  );
                } else {
                  return <>
                    <li key={index} className={navaccess?.active ? "active" : ""}
                      onClick={(e) => handleClickMenu(index,null)}>
                      <Link className="has-arrow" to={navaccess.link} aria-expanded="false">
                        <div className="nav_icon_small">
                          <img src={navaccess.icon} alt="home-icon" />
                        </div>
                        <div class="nav_title">
                          <span>{navaccess.label}</span>
                        </div>
                      </Link>

                    </li>
                  </>
                }

              }

            })}

          </ul>
        </div>
      </nav>
    </div>
    
    </>
  );
};

export default Navbar; 
